module.exports = __webpack_public_path__ + "static/service_bg2@3x-b178c1b09bd4d7016f05db5e31ce586b.png";